import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {ViewProps} from './model';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../shared/routing';
import {useTheme} from '../../../../shared/theme';
import {DeviceSize} from '../../../../shared/theme/helpers';

export default ({nextNews, prevNews}: ViewProps) => {
  const navigation = useNavigation();
  const theme = useTheme();

  const styles = useStyles(({theme: theme_, addShadow, mediaOnly}) => ({
    container: {
      paddingTop: 40,
      paddingBottom: 60,
      backgroundColor: theme_.color.gray200,
    },
    card: {
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.25,
      }),
      padding: 20,
      backgroundColor: theme_.color.blue100,
      marginHorizontal: 20,
      borderRadius: 5,
    },
    cardNext: {
      marginTop: 20,
      alignItems: 'flex-end',
    },
    cardButton: {
      flexDirection: 'row',
      width: '100%',
      minHeight: 24,
      ...mediaOnly(
        DeviceSize.desktop,
        {maxHeight: theme.fonts.action.lineHeight},
        {maxHeight: theme.fonts.h6.lineHeight},
      ),
      marginBottom: 10,
    },
    cardButtonPrev: {
      justifyContent: 'flex-start',
    },
    cardButtonNext: {
      justifyContent: 'flex-end',
    },
    cardButtonText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.action, theme.fonts.h6),
      color: theme_.color.gray700,
    },
    textLeft: {
      marginLeft: 2,
      ...theme_.fonts.body,
      color: theme_.color.gray700,
    },
    textRight: {
      marginRight: 2,
      ...theme_.fonts.body,
      color: theme_.color.gray700,
    },
  }));

  return (
    <View style={styles.container}>
      {prevNews?.id ? (
        <View style={styles.card}>
          <TouchableOpacity
            testID={`footer-news-article-to-prev-${prevNews.id}-id`}
            onPress={() => navigation.navigate(Screens.NewsArticle, {id: prevNews.id})}>
            <View style={[styles.cardButton, styles.cardButtonPrev]}>
              <images.Left width={18} color={theme.color.primaryColor} />
              <Text style={[styles.cardButtonText, styles.textLeft]}>Предыдущая</Text>
            </View>
          </TouchableOpacity>
          <Text>{prevNews.name}</Text>
        </View>
      ) : (
        <View />
      )}
      {nextNews?.id ? (
        <View style={[styles.card, styles.cardNext]}>
          <TouchableOpacity
            testID={`footer-news-article-to-next-${nextNews.id}-id`}
            onPress={() => navigation.navigate(Screens.NewsArticle, {id: nextNews.id})}>
            <View style={[styles.cardButton, styles.cardButtonNext]}>
              <Text style={[styles.cardButtonText, styles.textRight]}>Следующая</Text>
              <images.Right width={18} color={theme.color.primaryColor} />
            </View>
          </TouchableOpacity>
          <Text>{nextNews.name}</Text>
        </View>
      ) : (
        <View />
      )}
    </View>
  );
};
